import {styled, Typography} from '@innowise-group/ui-kit';

export const MeetingRoomInfo = styled(Typography)<{isBusy: boolean}>`
  word-break: break-word;
  white-space: normal;
  color: ${({isBusy, theme}) => (isBusy ? theme.palette.specials.meetings.textBusy : theme.palette.general.green[100])};
  text-overflow: ellipsis;
  text-align: start;
  position: relative;
  padding-left: 17px;
  font-family: Manrope;
  font-weight: 500;
  line-height: 1.375;
  letter-spacing: 0.25px;

  @media (max-width: 769px) {
    padding-left: 16px;
  }

  @media (max-width: 481px) {
    padding-left: 14px;
  }

  &:before {
    content: '';
    position: absolute;
    display: block;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: ${({isBusy, theme}) =>
      isBusy ? theme.palette.specials.meetings.backBusy : theme.palette.general.green[80]};
    left: 3px;
    top: 4px;

    @media (max-width: 769px) {
      width: 10px;
      height: 10px;
    }

    @media (max-width: 481px) {
      width: 8px;
      height: 8px;
    }
  }
`;
